export default "__VITE_ASSET__CDmELx9L__"